var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCpl(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_656_7934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99187 12.8191C10.2099 12.8191 12.8187 10.2103 12.8187 6.99224C12.8187 3.77417 10.2099 1.16541 6.99187 1.16541C3.7738 1.16541 1.16504 3.77417 1.16504 6.99224C1.16504 10.2103 3.7738 12.8191 6.99187 12.8191Z",
    stroke: "#8B5CF6",
    strokeWidth: 1.16537,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99219 10.4883C8.92304 10.4883 10.4883 8.92304 10.4883 6.99219C10.4883 5.06135 8.92304 3.49609 6.99219 3.49609C5.06135 3.49609 3.49609 5.06135 3.49609 6.99219C3.49609 8.92304 5.06135 10.4883 6.99219 10.4883Z",
    stroke: "#8B5CF6",
    strokeWidth: 1.16537,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99252 8.15758C7.63613 8.15758 8.15788 7.63582 8.15788 6.99221C8.15788 6.3486 7.63613 5.82684 6.99252 5.82684C6.3489 5.82684 5.82715 6.3486 5.82715 6.99221C5.82715 7.63582 6.3489 8.15758 6.99252 8.15758Z",
    stroke: "#8B5CF6",
    strokeWidth: 1.16537,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_656_7934"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.9844,
    height: 13.9844,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpl);
export default __webpack_public_path__ + "static/media/cpl.7f9e2931d9c9badc38ffa0b68c62cce6.svg";
export { ForwardRef as ReactComponent };